import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'mtn-number-field',
  templateUrl: './number-field.component.html',
  styleUrls: ['./number-field.component.scss']
})
export class NumberFieldComponent {

  @Input() form: UntypedFormGroup;
  @Input() controlName: string;
  @Input() isRequired = false;
  @Input() placeholder: string;
  @Input() requiredMessage: string;

  JSON = JSON;

  constructor() { }

  blockNonNumeric(event: KeyboardEvent): void {

    if (event.key == 'e' || event.key == 'E' || event.key == '.'  ) {
      event.preventDefault();
    }
  }

}
